var m = require('mithril');
var prop = require('mithril/stream');
var modal = require('../layout/components/modal');
var loaders = require('../layout/components/loaders');
var ToggleSwitch = require('../components/toggleSwitch');

var discoveryModal = {};

var descendantLabels = {
  LontalkChannel: 'Discover Devices only, or continue through Function Blocks, Network Variables, and Points.',
  LontalkDevice: 'Discover Function Blocks only, or continue through Network Variables and Points.',
  FunctionBlock: 'Discover Network Variables only, or continue and generate their Points.'
};

function errorMessage (error) {
  if (!error) return 'LonTalk discovery failed.';
  if (typeof error === 'string') return error;
  return error.error || error.message ||
    error.response && (error.response.cause || error.response.error) ||
    'LonTalk discovery failed.';
}

discoveryModal.open = function (record, onDone) {
  var recursive = prop(false);
  var running = prop(false);
  var error = prop('');

  function setButtons () {
    modal.vm.buttons([
      {
        label: 'Cancel',
        class: '',
        disabled: running(),
        func: function () { modal.vm.close(); }
      },
      {
        label: running() ? 'Discovering…' : 'Discover',
        class: 'btn-good',
        disabled: running(),
        func: submit
      }
    ]);
  }

  function submit () {
    if (running()) return;
    running(true);
    error('');
    setButtons();
    m.redraw();

    return loaders.requestWithLoader({
      url: record['@id'] + '/sync/?recursive=' + String(recursive()),
      method: 'GET',
      loader: 'submit'
    })
    .then(function (response) {
      modal.vm.close();
      if (typeof onDone === 'function') {
        return onDone(response);
      }
      return response;
    })
    .catch(function (requestError) {
      error(errorMessage(requestError));
      running(false);
      setButtons();
      m.redraw();
    });
  }

  modal.vm.title('Discover ' + (record.name || record['@class'] || 'LonTalk'));
  modal.vm.body = function () {
    return m('div', [
      m('p.mt0.moon-gray', descendantLabels[record['@class']] || 'Discover child records from EES.'),
      error() ? m('div.red.mb3', error()) : null,
      m('div.flex.items-center.justify-between.ba.b--mid-gray.pa3', [
        m('div.pr3', [
          m('label.db.f4', {for: 'lontalk-recursive-discovery'}, 'Recursive'),
          m('div.f6.moon-gray.mt1', 'Continue discovery through every descendant level.')
        ]),
        m(ToggleSwitch, {
          id: 'lontalk-recursive-discovery',
          size: 'modal',
          checked: recursive(),
          disabled: running(),
          ariaLabel: 'Discover recursively',
          onchange: function (event) { recursive(event.target.checked); }
        })
      ])
    ]);
  };
  setButtons();
  modal.vm.open();
};

module.exports = discoveryModal;
